import { IconBuildingBank } from '@tabler/icons';

const dashboard = {
  id: 'bank',
  title: 'Bank',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Bank',
      type: 'item',
      url: '/bank/default',
      icon: IconBuildingBank,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
